WiseMetering.Views.IndexSiteTags = WiseMetering.Views.TableIndex.extend({
    icon: 'tags',

    createTable: function() {
        return new WiseMetering.Views.Table({
            id: 'site_tags',
            collection: WiseMetering.siteTags,
            columns: {
                name: i18next.t('common.name'),
                siteNames: i18next.t('glossary.sites')
            },
            modelSerializer: function(model) {
                return {
                    siteNames: model.siteNames().sort().join(' | '),
                    id: model.id,
                    name: model.get('name')
                };
            },
            toolbar_actions: {
                new: {
                    view_call: () => new WiseMetering.Views.NewSiteTag({
                        collection: WiseMetering.siteTags,
                        model: new WiseMetering.Model.SiteTag
                    })
                },
                edit: {
                    view_call: model => new WiseMetering.Views.EditSiteTag({ model })
                },
                delete: {
                    permission: 'administrator',
                    view_call: model => new WiseMetering.Views.Modal.Destroy({
                        model,
                        title: () => i18next.t('modal.title.site_tags.destroy')
                    })

                }
            }
        });
    },

    name: function() {
        return i18next.t('glossary.site_tags');
    }
});
